import UserCard from './UserCard';

export * from './UserCard';

export default UserCard;
